The instructions related to posting the job ad.

Scheme requirements:

- The `seekAnz` scheme requires exactly one element.
